/*
         * @ngdoc function
         * @name ePay.Model:Session_XMLPaymentModel
         * @description
         * Model
         */
import { Session_AgencyModel } from './Session_AgencyModel';
import { Session_EPayOptionsModel } from './Session_EPayOptionsModel';
import { Session_CreditCardsModel } from './Session_CreditCardsModel';
import { Session_PaymentOptionsModel } from './Session_PaymentOptionsModel';
import { Session_PreQuestionareModel } from './Session_PreQuestionareModel';
import { Session_ValidationModel } from './Session_ValidationModel';
import { Session_RevenueModel } from './Session_RevenueModel';
import { Session_ButtonsModel } from './Session_ButtonsModel';
import { Session_Devices } from './Session_Devices';

export class Session_XMLPaymentModel {
	agency: Session_AgencyModel;
	ePayOptions: Session_EPayOptionsModel;
	creditCards: Session_CreditCardsModel;
	paymentOptions: Session_PaymentOptionsModel;
  shoppingCart: string | null | undefined;
	preQuestionare: Session_PreQuestionareModel;
  databaseUpdate: string | null | undefined;
  postQuestionare: string | null | undefined;
	validation: Session_ValidationModel;
	revenue: Session_RevenueModel[];
	buttons: Session_ButtonsModel;
  groupId: string | null | undefined;
  devices: Session_Devices | null | undefined;

	constructor(
		agency?: Session_AgencyModel, 
		ePayOptions?: Session_EPayOptionsModel, 
		creditCards?: Session_CreditCardsModel, 
		paymentOptions?: Session_PaymentOptionsModel, 
		shoppingCart?: string, 
		preQuestionare?: Session_PreQuestionareModel, 
		databaseUpdate?: string, 
		postQuestionare?: string, 
		validation?: Session_ValidationModel, 
		revenue?: Session_RevenueModel[], 
    buttons?: Session_ButtonsModel,
    devices?: Session_Devices,
		groupId?: string
	) {
		this.agency = agency || new Session_AgencyModel();
		this.ePayOptions = ePayOptions || new Session_EPayOptionsModel();
		this.creditCards = creditCards || new Session_CreditCardsModel();
		this.paymentOptions = paymentOptions || new Session_PaymentOptionsModel();
		this.shoppingCart = shoppingCart || null;
		this.preQuestionare = preQuestionare || new Session_PreQuestionareModel();
		this.databaseUpdate = databaseUpdate || null;
		this.postQuestionare = postQuestionare || null;
		this.validation = validation || new Session_ValidationModel();
		this.revenue = revenue || [];
		this.buttons = buttons || new Session_ButtonsModel();
    this.groupId = groupId || null;
    this.devices = devices || null;
	}
}
